import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useCommentInquiry from './hooks/useCommentInquiry';

interface Params {
    inquiryId: string;
    content: string;
    fileUrls: string[];
}

declare module '@stackflow/config' {
    interface Register {
        InquiryCommentModal: Params;
    }
}

const InquiryCommentModal: ActivityComponentType<'InquiryCommentModal'> = ({ params }) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId, content, fileUrls } = params;
    const { pop } = useFlow();
    const handleCommentInquiry = useCommentInquiry(inquiryId);
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column fullWidth align='center' spacing={8}>
                        <Title size='3xl' fontWeight='bold' align='center' >
                            {t('comment.confirmTitle')}
                        </Title>
                        <Text color={colors.gray6}>
                            {t('comment.confirmDescription')}
                        </Text>
                    </Column>
                    <Row fullWidth spacing={10}>
                        <Button variant='secondary' fullWidth onClick={pop} noPadding>
                            {t('comment.cancel')}
                        </Button>
                        <Button fullWidth
                            noPadding
                            onClick={() => handleCommentInquiry(content, fileUrls)}>
                            {t('comment.register')}
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

const Title = styled(Text)`
    word-break: break-word;
`;

export default InquiryCommentModal;
